export const apiUrls = {
  getCheckoutDetails: '/orderprocessservice/checkoutapi/nse/v2/5g/get-checkout-details',
  checkoutCaas: '/homeservices/expresscheckout.model.json',
  validEmailApi: '/fraudservice/validate/nse/5g/emailValidate',
  verifyEmailApi: '/fraudservice/validate/nse/5g/verifyEmail',
  verifyMobileApi: '/consentservice/consent/nse/getSMSConsent',
};
